export default "__VITE_ASSET__wsfvK27i__"